import React from 'react';
import { motion } from 'framer-motion';
import { useMetronome } from '../contexts/MetronomeContext';
import { useLanguage } from '../contexts/LanguageContext';
import TimeSignatureSelector from './TimeSignatureSelector';
import NoteTypeSelector from './NoteTypeSelector';
import SoundSelector from './SoundSelector';
import BeatIndicators from './BeatIndicators';

const BeatDisplay = () => {
  const { 
    beatsPerMeasure,
    currentRhythmType
  } = useMetronome();
  const { t } = useLanguage();

  return (
    <div className="flex flex-col">
      {/* Beat Visualization */}
      <motion.div 
        className="bg-gray-50 dark:bg-gray-700 rounded-xl p-4 mb-4 flex-1"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        <TimeSignatureSelector />
        <BeatIndicators />
        
        {/* Removed duplicate status display */}
      </motion.div>
      
      <NoteTypeSelector />
      
      {/* Sound Selection - Always visible */}
      <div className="mb-4">
        <SoundSelector />
      </div>
    </div>
  );
};

export default BeatDisplay;